export default __webpack_public_path__ + "static/media/program-1.63319a55.jpg";